import { Skeleton, Stack, SkeletonText, Flex } from '@chakra-ui/react';

function ClassItemLoading({ ...rest }) {
  return (
    <Flex
      {...rest}
      direction={{ base: 'column', sm: 'row' }}
      borderWidth="1px"
      borderRadius="sm"
    >
      <Skeleton h="100%" w={{ base: '100%', sm: '300px' }} />
      <Stack flex={1} p={4}>
        <SkeletonText
          minHeight="45px"
          noOfLines={1}
          spacing="4"
          skeletonHeight="4"
        />

        <SkeletonText
          minHeight="32px"
          noOfLines={2}
          spacing="2"
          skeletonHeight="2"
        />
      </Stack>
    </Flex>
  );
}

export default ClassItemLoading;
